import React from "react";
import { ActionsGrid, ActionButton } from "./styles";
import { ReactComponent as SendIcon } from "../../../../../../assets/kinologyIcons/svg/send.svg";
import { ReactComponent as DocsIcon } from "../../../../../../assets/kinologyIcons/svg/docs_dash.svg";
import { ReactComponent as MonitoringIcon } from "../../../../../../assets/kinologyIcons/svg/monitoring.svg";
import { ReactComponent as WarningIcon } from "../../../../../../assets/kinologyIcons/svg/warning_dash.svg";

interface CopilotActionsProps {
	isV1Mode: boolean;
	activeTab?: "resumo" | "evolucao" | "atencao";
	onSendReport: () => void;
	onViewSummary: () => void;
	onViewEvolution: () => void;
	onViewAttentionPoints: () => void;
	sendingReport?: boolean;
}

const CopilotActions: React.FC<CopilotActionsProps> = ({
	isV1Mode,
	activeTab,
	onSendReport,
	onViewSummary,
	onViewEvolution,
	onViewAttentionPoints,
	sendingReport = false,
}) => {
	return (
		<ActionsGrid>
			<ActionButton
				isPrimary
				onClick={onSendReport}
				disabled={sendingReport}
				type="button"
				aria-label="Enviar relatório"
			>
				<SendIcon width="12px" height="12px" />
				{sendingReport ? "Carregando..." : "Enviar Relatório"}
			</ActionButton>

			{!isV1Mode && (
				<>
					<ActionButton
						onClick={onViewSummary}
						isActive={activeTab === "resumo"}
						type="button"
						aria-label="Resumo do paciente"
					>
						<DocsIcon width="12px" height="12px" fill="#ffffff" />
						Resumo do Paciente
					</ActionButton>
					<ActionButton
						onClick={onViewEvolution}
						isActive={activeTab === "evolucao"}
						type="button"
						aria-label="Evolução"
					>
						<MonitoringIcon width="12px" height="12px" fill="#ffffff" />
						Evolução
					</ActionButton>
					<ActionButton
						onClick={onViewAttentionPoints}
						isActive={activeTab === "atencao"}
						type="button"
						aria-label="Pontos de atenção"
					>
						<WarningIcon width="12px" height="12px" fill="#ffffff" />
						Pontos de atenção
					</ActionButton>
				</>
			)}
		</ActionsGrid>
	);
};

export default CopilotActions;
